import { QueryClient } from "@tanstack/react-query";

/**
 * Shared QueryClient with application-wide defaults.
 *
 * Data is cached for 5 minutes; pass `staleTime: 0` to a query that must always refetch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

export default queryClient;
